const appLoaded = (): void => {
  document.body.classList.remove('app-loading');
  document.body.classList.add('loaded');
};

export default appLoaded;
